import { render, staticRenderFns } from "./StepInicio.vue?vue&type=template&id=f9ea904a&scoped=true&"
import script from "./StepInicio.vue?vue&type=script&lang=js&"
export * from "./StepInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ea904a",
  null
  
)

export default component.exports